export { EloChildIndicatorIcon } from './child-icon'
